import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, Modal } from "antd";
import { Error, Success } from "../Messages/Messages";
import axios from "axios";
import { EditOutlined } from "@ant-design/icons";
import { generalErrorAlert } from "../GeneralErrorAlert";
import { useTranslation } from "react-i18next";

export const UpdateInventory = ({ inventory, updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      form.setFieldsValue({
        itemName: inventory.itemName,
        total: inventory.total,
        minimumAmount: inventory.minimumAmount,
        notes: inventory.notes
      });
    }
  }, [isModalOpen, inventory, form]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onFinish = async values => {
    try {
      setLoading(true);
      await axios
        .put(`${process.env.REACT_APP_BACKEND_URL}/inventory/update/${inventory._id}`, values, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        })
        .then(res => {
          setLoading(false);
          if (res.status === 200 || res.status === 304) {
            Success(res.data.successMessage);
            handleCancel();
            updateParent();
          } else {
            Error(res.data.errorMessage);
          }
        })
        .catch(err => {
          setLoading(false);
          generalErrorAlert(err);
        });
    } catch (error) {
      setLoading(false);
      generalErrorAlert(error);
    }
  };

  return (
    <>
      <Button type="text" onClick={showModal} icon={<EditOutlined />}>
        {t("Edit")}
      </Button>
      <Modal
        width={600}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            {t("Cancel")}
          </Button>,
          <Button key="submit" loading={loading} type="primary" onClick={() => form.submit()}>
            {t("Update Item")}
          </Button>
        ]}
        title={t("Update Item")}
        open={isModalOpen}
        onCancel={handleCancel}
      >
        <Form form={form} onFinish={onFinish} layout="vertical" className="mt-3">
          <Form.Item
            label={t("Item Name")}
            name="itemName"
            rules={[{ required: true, message: t("enter", { field: t("item name") }) }]}
          >
            <Input placeholder={t("enter", { field: t("item name") })} />
          </Form.Item>
          <Form.Item
            label={t("Total Quantity")}
            name="total"
            rules={[{ required: true, message: t("enter", { field: t("total quantity") }) }]}
          >
            <InputNumber
              min={0}
              style={{ width: "100%" }}
              placeholder={t("enter", { field: t("total quantity") })}
            />
          </Form.Item>
          <Form.Item label={t("Minimum quantity to notify")} name="minimumAmount">
            <InputNumber
              min={0}
              style={{ width: "100%" }}
              placeholder={t("enter", { field: t("minimum quantity") })}
            />
          </Form.Item>
          <Form.Item label={t("Notes")} name="notes">
            <Input.TextArea rows={4} placeholder={t("Add any additional notes")} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
